import {RootState} from '../../store';

const key = 'zones';

// FNP-1293 — the selection slice, keyed by zone id.
export const selectionSelector = (state: RootState) => {
    return state[key].selection;
};
